function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.98 6.938h-.359v10.125h.359V6.938zm-.745 1.125h-.36v7.875h.36V8.063zm-1.116 0H0v7.875h16.119V8.063zm7.881 0h-4.508v7.875H24V8.063zm-5.256 0h-.36v7.875h.36V8.063z",
  fill: "#222"
});

function SvgStitcher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "simpleicons-stitcher-icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsbGVkYnk9InNpbXBsZWljb25zLXN0aXRjaGVyLWljb24iIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuOTggNi45MzhoLS4zNTl2MTAuMTI1aC4zNTlWNi45Mzh6bS0uNzQ1IDEuMTI1aC0uMzZ2Ny44NzVoLjM2VjguMDYzem0tMS4xMTYgMEgwdjcuODc1aDE2LjExOVY4LjA2M3ptNy44ODEgMGgtNC41MDh2Ny44NzVIMjRWOC4wNjN6bS01LjI1NiAwaC0uMzZ2Ny44NzVoLjM2VjguMDYzeiIgZmlsbD0iIzIyMiIvPjwvc3ZnPgo=";
export { SvgStitcher as ReactComponent };